import React, { useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";

const ClosedLoopAndSceneExtract = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div data-test="closedLoopAndSceneExtractComponent">
      <Breadcrumb>
        <Breadcrumb.Item href="">
          <Link to="navigate_new">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="">
          <Link to="/welcome">Welcome</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="/close_loop" active>
          {" "}
          Close loop
        </Breadcrumb.Item>
      </Breadcrumb>

      <div className="container" style={{ paddingTop: "5%" }}>
        <div className="card">
          <div
            className="card-header"
            style={{
              backgroundColor: "#757AF7",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h1>
              {window.location.pathname === "/scene_extract"
                ? "Scene Extract"
                : "Close Loop"}
            </h1>

            <select
              style={{
                padding: "8px",
                fontSize: "25px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                backgroundColor: "#ADFF2F",
                color: "black",
              }}
              onChange={handleOptionChange}
            >
              <option value="carmaker">Carmaker</option>
              <option value="carla">Carla</option>
            </select>
          </div>
          <div className="card-body">
            <div className="container">
              <div className="row" style={{ paddingTop: "2%" }}>
                {/* <div className="col-6">
                                <div className="card">
                                    <div className="card-body align-items-center" style={{ height: "100%" }}>
                                        <h4 style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "bold", color: "#622AD8" }}>
                                            Data Pipeline
                                        </h4>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Link to="/k-data_analyzer" style={{ textDecoration: "none", color: "black" }}>
                                                    <div className="card" id="info-box">
                                                        <div className="card-body align-items-center d-flex justify-content-center">
                                                            K-Data Analyzer
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="card" id="info-box">
                                                            <div className="card-body align-items-center d-flex justify-content-center">
                                                                Search
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row" style={{ paddingTop: "2%" }}>
                                                    <div className="col-md-12">
                                                        <div className="card" id="info-box">
                                                            <div className="card-body align-items-center d-flex justify-content-center">
                                                                Anomaly
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingTop: "2%" }}>
                                            <div className="col-md-6">
                                                <div className="card" id="info-box">
                                                    <div className="card-body align-items-center d-flex justify-content-center">
                                                        Manage Data
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="card" id="info-box">
                                                            <div className="card-body align-items-center d-flex justify-content-center">
                                                                Trend
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row" style={{ paddingTop: "2%" }}>
                                                    <div className="col-md-12">
                                                        <div className="card" id="info-box">
                                                            <div className="card-body align-items-center d-flex justify-content-center">
                                                                Data Down Selection
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>  */}
                <div className="col-12">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card" id="info-box">
                        <div className="card-body">
                          {/* <h4 style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#757AF7" }}>
                                                    {selectedOption === "carla" ? "Carla Base Scenario Collection" : "Carmaker Base Scenario Collection"}
                                                </h4> */}

                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "1.8rem",
                              fontWeight: "900",
                              color: "#757AF7",
                            }}
                          >
                            <Link
                              to={
                                selectedOption === "carla"
                                  ? "/close_loop_scenario_collection_enhanced"
                                  : "/close_loop_cm_scenario_collection_enhanced"
                              }
                            >
                              Base Scenario Collection
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card" id="info-box">
                        <div className="card-body">
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "1.8rem",
                              fontWeight: "900",
                              color: "#757AF7",
                            }}
                          >
                            <Link to="/close_loop_criteria_masters">
                              Criteria Mapping
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: "2%" }}>
                    <div className="col-md-6">
                      <div className="card" id="info-box">
                        <div className="card-body">
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "1.8rem",
                              fontWeight: "900",
                              color: "#757AF7",
                            }}
                          >
                            <Link
                              to={
                                selectedOption === "carla"
                                  ? "/close_loop_scenario_group"
                                  : "/close_cm_loop_scenario_group"
                              }
                            >
                              Scenario Group
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card" id="info-box">
                        <div className="card-body">
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "1.8rem",
                              fontWeight: "900",
                              color: "#757AF7",
                            }}
                          >
                            <Link
                              to={
                                selectedOption === "carla"
                                  ? "/close_loop/topology"
                                  : "/close_loop/close_cm_loop_topology"
                              }
                            >
                              CAD Topology
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row" style={{ paddingTop: "2%" }}>
                                    <div className="col-md-12">
                                        <Link to="/scenario_variation/upload" >
                                            <div className="card" id="info-box">
                                                <div className="card-body">
                                                    <h4 style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: "900", color: "#622AD8" }}>
                                                        Scenario Variation Upload
                                                    </h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div> */}
                  <div className="row" style={{ paddingTop: "2%" }}>
                    <div className="col-md-6">
                      <div className="card" id="info-box">
                        <div className="card-body">
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "1.8rem",
                              fontWeight: "900",
                              color: "#757AF7",
                            }}
                          >
                            <Link
                              to={
                                selectedOption === "carla"
                                  ? "/close_loop/individual/kpi/dashboard"
                                  : ""
                              }
                            >
                              KPI Dashboard
                            </Link>
                          </div>
                          <div className="row">
                            {/* <div className="col-md-6">
                                                        {selectedOption === "carla" && (
                                                            <Link to="/close_loop/individual/kpi/dashboard" >
                                                                <a style={{ float: "right", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                    Carla
                                                                </a>
                                                                  KPI Dashboard
                                                            </Link>
                                                        )}
                                                        </div>
                                                        <div className="col-md-6">
                                                        {selectedOption === "carmaker" && (
                                                            <a style={{ float: "left", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                Carmaker
                                                            </a>
                                                        )}
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card" id="info-box">
                        <div className="card-body">
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "1.8rem",
                              fontWeight: "900",
                              color: "#757AF7",
                            }}
                          >
                            <Link
                              to={
                                selectedOption === "carla"
                                  ? "/close_loop/real_time/apm/dashboard"
                                  : ""
                              }
                            >
                              Docker Stats
                            </Link>
                          </div>
                          <div className="row">
                            {/* <div className="col-md-6">
                                                        {selectedOption === "carla" && (
                                                            <Link to="/close_loop/real_time/apm/dashboard" >
                                                                <a style={{ float: "right", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                    Carla
                                                                </a>
                                                                Docker Stats
                                                            </Link>
                                                        )}
                                                        </div>
                                                        <div className="col-md-6">
                                                        {selectedOption === "carmaker" && (
                                                            <a style={{ float: "left", fontSize: "1rem", fontWeight: "500", color: "#757AF7" }}>
                                                                Carmaker
                                                            </a>
                                                        )}
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     
    </div>
  );
};
// const ClosedLoopAndSceneExtract = () => (
//     <div>
//         <div className="container" style={{ paddingTop: "5%" }}>
//             <div className="card">
//                 <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
//                     <h1>{window.location.pathname === "/scene_extract" ?
//                     "Scene Extract"
//                     : "Close Loop"}</h1>
//                 </div>
//                 <div className="card-body">
//                     <div className="container">
//                         <div className="row" style={{ paddingTop: "2%" }}>
//                              <div className="col-6">
//                                 <div className="card">
//                                     <div className="card-body align-items-center" style={{ height: "100%" }}>
//                                         <h4 style={{ textAlign: "center", fontSize : "1.8rem",fontWeight: "bold", color: "#622AD8" }}>
//                                             Data Pipeline
//                                         </h4>
//                                         <div className="row">
//                                             <div className="col-md-6">
//                                                 <Link to="/k-data_analyzer" style={{ textDecoration: "none", color: "black" }}>
//                                                     <div className="card" id="info-box">
//                                                         <div className="card-body align-items-center d-flex justify-content-center">
//                                                             K-Data Analyzer
//                                                         </div>
//                                                     </div>
//                                                 </Link>
//                                             </div>
//                                             <div className="col-md-6">
//                                                 <div className="row">
//                                                     <div className="col-md-12">
//                                                         <div className="card" id="info-box">
//                                                             <div className="card-body align-items-center d-flex justify-content-center">
//                                                                 Search
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="row" style={{ paddingTop: "2%" }}>
//                                                     <div className="col-md-12">
//                                                         <div className="card" id="info-box">
//                                                             <div className="card-body align-items-center d-flex justify-content-center">
//                                                                 Anomaly
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row" style={{ paddingTop: "2%" }}>
//                                             <div className="col-md-6">
//                                                 <div className="card" id="info-box">
//                                                     <div className="card-body align-items-center d-flex justify-content-center">
//                                                         Manage Data
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6">
//                                                 <div className="row">
//                                                     <div className="col-md-12">
//                                                         <div className="card" id="info-box">
//                                                             <div className="card-body align-items-center d-flex justify-content-center">
//                                                                 Trend
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>

export default ClosedLoopAndSceneExtract;
